module.exports = __webpack_public_path__ + "static/media/fillcolor.8bdf7722.svg";